import React, { useEffect } from "react";
import { X, BookOpen } from "lucide-react";
import { brand } from "../mock/content";
import { t } from "../lib/ui";

export default function StudyModal({ onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[80] flex items-start md:items-center justify-center p-0 md:p-6" data-testid="study-modal">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} data-testid="study-modal-overlay" />
      <div className="relative w-full md:max-w-4xl max-h-full md:max-h-[92vh] overflow-y-auto bg-[#0a0a0a] text-white border border-white/10 md:rounded-lg shadow-2xl">
        {/* Header */}
        <div className="sticky top-0 z-10 flex items-center justify-between px-6 md:px-10 py-5 bg-[#0a0a0a]/95 backdrop-blur-md border-b border-white/10">
          <div>
            <span className="text-[11px] uppercase tracking-[0.2em] text-white/60" style={{ fontFamily: "Space Grotesk" }}>{t("study_eyebrow")}</span>
            <h2 className="mt-1 font-black text-2xl md:text-4xl tracking-tight" style={{ fontFamily: "Archivo" }}>{t("study_title")}</h2>
          </div>
          <button onClick={onClose} data-testid="study-modal-close" aria-label="Chiudi" className="p-2 text-white/60 hover:text-white hover:bg-white/10 rounded-full transition-colors shrink-0">
            <X size={24} />
          </button>
        </div>

        <div className="px-6 md:px-10 py-8">
          <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-start">
            <div className="lg:col-span-5">
              <p className="text-white/70 text-base leading-relaxed" style={{ fontFamily: "Inter" }}>{t("study_p1")}</p>
              <p className="mt-4 text-white/70 text-base leading-relaxed" style={{ fontFamily: "Inter" }}>{t("study_p2")}</p>
              <a href="https://doi.org/10.1016/j.xcrp.2026.103208" target="_blank" rel="noreferrer" className="mt-6 inline-flex items-start gap-2.5 text-xs text-white/60 hover:text-white/80 transition-colors leading-relaxed" style={{ fontFamily: "Space Grotesk" }} data-testid="study-modal-citation">
                <BookOpen size={16} className="mt-0.5 shrink-0" style={{ color: brand.yellow }} />
                <span>Vicari Stefani et al., «Increasing specific power and the emergence of new markets for crystalline silicon photovoltaics», <em>Cell Reports Physical Science</em> (2026) · DOI 10.1016/j.xcrp.2026.103208</span>
              </a>
            </div>
            <div className="lg:col-span-7">
              <div className="bg-white rounded-lg overflow-hidden border border-white/10">
                <img src="/tech/irs-study.jpeg?v=2" alt="Studio Cell Reports Physical Science sul rapporto massa/materiale nei moduli fotovoltaici" className="w-full h-auto block" data-testid="study-modal-img" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
